export const  CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const  CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const  CHANGE_PASSWORD_FAIL = 'CHANGE_PASSWORD_FAIL';
export const  CHANGE_PASSWORD_ = 'CHANGE_PASSWORD_FAIL';
export const  RESET_CHANGE_PASSWORD_FLAG = 'RESET_CHANGE_PASSWORD_FLAG';
